import React from 'react';
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Button,
    makeStyles,
    TableSortLabel,
    Toolbar,
    Tooltip,
    IconButton,
    Popover,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Grid,
} from "@material-ui/core";
import moment from "moment";
import { useSelector } from "react-redux";
import { getComparator, stableSort } from '../../../helpers/tables';
import FilterListIcon from '@material-ui/icons/FilterList';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { TURNOS_PERMISOS } from '../../../utils/permisos';

const useStyles = makeStyles((theme) => ({
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    toolbar: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        float: "right"
    }
}));

const titles = [
    {
        label: "Afiliado",
        sort: false
    },
    {
        label: "Fecha",
        sort: false
    },
    {
        label: "Hora",
        sort: true,
        id: "hora"
    },
    {
        label: "Sobre Turno",
        sort: false
    },
    {
        label: "Modalidad",
        sort: false
    },
    {
        label: "Asistio",
        sort: false
    }
]

export const ListaTurnosBaja = (props) => {
    const classes = useStyles();
    const { page, items, cargada, selected, isSelected, formatFecha, rowsPerPage, handleClick, handleSelectAllClick, handleSendBajaTurno } = props
    const { permisos: permisosUser } = useSelector(state => state.auth)

    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleSubmitFilter = (e) => {
        e.preventDefault()
        props.handleFilterSearch(props.tomadoLibre)
        handleClosePopover()
    }

    const handleClickPopover = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const open = Boolean(anchorEl);

    return (
        <Paper>
            <Toolbar
                className={classes.toolbar}
            >
                <Tooltip title="Filter list">
                    <IconButton aria-label="filter list" aria-describedby="popover-filtros-bajas" onClick={handleClickPopover}>
                        <FilterListIcon />
                    </IconButton>
                </Tooltip>
                <Popover
                    id={"popover-filtros-bajas"}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    PaperProps={{
                        style: { width: '10%', minWidth: 150 },
                    }}
                >
                    <div style={{ padding: "0.5rem" }}>
                        <Grid container>
                            <Grid item xs={12}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-helper-label">Tipo de Turno</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        name="tomadoLibre"
                                        value={props.tomadoLibre}
                                        onChange={props.handleInputChange}
                                        fullWidth
                                    >
                                        <MenuItem value={0}>
                                            <em>Todos</em>
                                        </MenuItem>
                                        <MenuItem value={1}>Tomado</MenuItem>
                                        <MenuItem value={2}>Libre</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} style={{ textAlign: "center", marginTop: "0.5rem" }}>
                                <Button variant="contained" size="small" color="inherit" type="button" onClick={handleSubmitFilter}>
                                    Filtrar
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </Popover>
            </Toolbar>
            <TableContainer >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell padding="checkbox">
                                <Checkbox
                                    indeterminate={selected.length > 0 && selected.length < items.length}
                                    disabled={!validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.BAJA)}
                                    // checked={items.length > 0 && selected.length === items.length}
                                    checked={items.length > 0 && selected.length > 0}
                                    onChange={handleSelectAllClick}
                                    inputProps={{ "aria-label": "select all desserts" }}
                                />
                            </TableCell>
                            {
                                titles.map(title => {
                                    if (title.sort) {
                                        return (
                                            <TableCell key={title.label} sortDirection={orderBy === title.id ? order : false} align="left">
                                                <TableSortLabel
                                                    active={orderBy === title.id}
                                                    direction={orderBy === title.id ? order : 'asc'}
                                                    onClick={() => handleRequestSort(title.id)}
                                                >
                                                    {title.label}
                                                    {orderBy === title.id ? (
                                                        <span className={classes.visuallyHidden}>
                                                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                                        </span>
                                                    ) : null}
                                                </TableSortLabel>
                                            </TableCell>
                                        )
                                    }
                                    return (
                                        <TableCell key={title.label} align="left">{title.label}</TableCell>
                                    )
                                })
                            }
                            <TableCell align="left"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items.length > 0
                            ?
                            (orderBy ? stableSort(items, getComparator(order, orderBy)) : items)
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((item, index) => {
                                    const isItemSelected = isSelected(item.idAgenda);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <React.Fragment key={item.idAgenda}>
                                            <TableRow>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isItemSelected}
                                                        inputProps={{ "aria-labelledby": labelId }}
                                                        disabled={item.confirmado || moment(item.fecha).isBefore(moment(), 'day') || !validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.BAJA)}
                                                        onClick={() => handleClick(item.idAgenda)}
                                                    />
                                                </TableCell>
                                                <TableCell align="left">
                                                    {!item.afiliado && !item.afiliadoExterno ? 'Sin Tomar' : item.afiliado?.apellido_y_nombre || item.afiliadoExterno?.apellidoNombre}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {formatFecha(item.fecha)}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.hora}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.sobreTurno ? 'Si' : 'No'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    {!item.afiliado && !item.afiliadoExterno
                                                        ?
                                                        item.idTipoTurno === 1 ? 'Presencial' : (item.idTipoTurno === 2 ? 'Virtual' : 'Presencial o Virtual')
                                                        :
                                                        item.idTipoTurnoSol === 1 ? 'Presencial' : 'Virtual'
                                                    }
                                                </TableCell>
                                                <TableCell align="left">
                                                    {item.confirmado ? 'Si' : 'No'}
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Button
                                                        style={{ marginLeft: -2 }}
                                                        variant="contained"
                                                        onClick={() => handleSendBajaTurno(item)}
                                                        disabled={item.confirmado || moment(item.fecha).isBefore(moment(), 'day') || !validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.BAJA)}
                                                        color="primary"
                                                    >
                                                        Baja
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    )
                                })
                            :
                            (cargada &&
                                <TableRow style={{ height: 50 }}>
                                    <TableCell colSpan={8} style={{ textAlign: '-webkit-center' }}> Sin Registros</TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
}